export enum RegisterSituationEnum {
    ENABLED = 'Ativo',
    DISABLED = 'Inativo',
}

export type RegisterSituation = 'ENABLED' | 'DISABLED';
